import { Component, OnInit } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { FieldConfig } from '../../../interfaces/field.interface';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
@Component({
  selector: 'app-button',
  template: `
    <div [formGroup]="group">
      <div class="down">
        <ion-button class="btn-default" expand="block" type="submit">
          {{ 'Salvar' | translate }}
        </ion-button>
      </div>
    </div>
  `,
  styles: [
    `
      .down {
        margin: 40px 0px 40px !important;
      }
    `,
  ],
  standalone: true,
  imports: [IonicModule, CommonModule, TranslateModule, ReactiveFormsModule],
})
export class ButtonComponent implements OnInit {
  field: FieldConfig;
  group: FormGroup;
  constructor() {}
  ngOnInit() {}
}
